import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { SERVICE_LINE_ISSUE_TEXT } from '../utilities/partServiceLine';

const TOOLTIPS = {
  none: 'Requested as not for a service line — check the work will happen before ordering',
  closed: "This part's service line is complete or declined — check the part is still needed",
};

// Marks a part that isn't tied to an open service line, so the reviewer checks
// the work will actually happen before ordering it. `issue` comes from
// Store.attachServiceLineIssues; renders nothing when it is empty. Uses
// warning.dark — warning.main is too light to read as text.
const ServiceLineChip = ({ issue, sx }) => {
  if (!issue) return null;
  return (
    <Tooltip title={TOOLTIPS[issue]}>
      <Chip
        label={SERVICE_LINE_ISSUE_TEXT[issue]}
        size="small"
        variant="outlined"
        sx={{ color: 'warning.dark', borderColor: 'warning.dark', fontWeight: 600, height: 20, ...sx }}
      />
    </Tooltip>
  );
};

export default ServiceLineChip;
